<template>
    <!-- <CustomHeader :text="$t('weeklyCompensation.title')" /> -->

    <van-row>
        <van-col span="24">
            <div class="weekly-banner">
                <img src="@/assets/WeeklyCompensation/weekbv2_top_banner.png" alt="banner" class="weekly-img" />
            </div>
        </van-col>
    </van-row>

    <div class="week_container">
        <van-row>
            <van-col span="24">
                <div class="compensation-card">
                    <img src="@/assets/WeeklyCompensation/weekb_frame_top.png" alt="banner" class="top-card-bg" />
                </div>
            </van-col>
        </van-row>
        <van-row class="top-box">
            <van-col span="24">
                <span class="top-text">
                    <span class="from">{{ $t('weeklyCompensation.the') }} </span>
                    <span class="from-date"> 2025-05-05 05:30 </span>
                    <span class="to"> {{ $t('weeklyCompensation.to') }} </span>
                    <span class="to-date"> 2025-05-12 05:30 </span>
                </span>
                <span class="top-compensation">{{ $t('weeklyCompensation.weeklyCompensation') }}:</span>
                <span class="top-compensation-amount">R$ <span style="color: #000;">0</span></span>
                <span class="top-profit">{{ $t('weeklyCompensation.profit') }}：</span>
                <span class="top-profit-amount">R$ 0</span>
            </van-col>
        </van-row>

        <van-row>
            <van-col span="24">
                <div class="compensation-middle-card">
                    <img src="@/assets/WeeklyCompensation/weekb_frame_bottom.png" alt="banner" class="middle-card-bg" />
                    <span class="middle-compensation">{{ $t('weeklyCompensation.distribute') }}</span>
                    <span class="middle-date">2025-05-13 01:30</span>
                    <img src="@/assets/WeeklyCompensation/weekb_icon_time.png" alt="banner" class="middle-time-icon" />
                    <img src="@/assets/WeeklyCompensation/weekb_week_text.png" alt="banner"
                        class="middle-moneybag-icon" />
                    <span class="middle-available-compensation">{{ $t('weeklyCompensation.available') }}</span>
                    <span class="middle-available-amount">R$ <span style="color:#FFFFFF73;font-size: 20px;">{{
                        availableBalance }}</span></span>
                    <div
                        v-bind:class="availableBalance > 0 ? 'exchange-btn exchange-btn-active' : 'exchange-btn exchange-btn-disabled'">
                    </div>
                </div>
            </van-col>
        </van-row>
        
        <van-row class="detail-table">
            <van-col span="11" class="table-title">
                <span style="color: #FFFFFF;">{{ $t('weeklyCompensation.profit') }}</span>
            </van-col>
            <van-col span="2"></van-col>
            <van-col span="11" class="table-title">
                <span style="color: #FFFFFF;">{{ $t('weeklyCompensation.compensation') }}</span>
            </van-col>
        </van-row>
        <van-row class="detail-stable" v-for="(i, index) in commissionList" :key="i+'i'">
            <van-col span="11" :class="['table-row', index % 2 === 0 ? 'light' : 'dark']">
                <span style="color: #ffffff73;">{{ i.title }}</span>
            </van-col>
            <van-col span="2"></van-col>
            <van-col span="11" :class="['table-row', index % 2 === 0 ? 'light' : 'dark']">
                <span style="color: #FFFFFF;">{{ i.value }}</span>
            </van-col>
        </van-row>


        <van-row class="activity-title-row">
            <van-col span="6">
                <div class="left-img"></div>
            </van-col>
            <van-col span="12"><span class="activity-title">{{ $t('common.activityTitle') }}</span></van-col>
            <van-col span="6">
                <div class="right-img"></div>
            </van-col>
        </van-row>
        <van-row>
            <van-col span="24">
                <span class="activity-text">
                    <p v-html="$t('weeklyCompensation.activityContent')"></p>
                </span>
            </van-col>
        </van-row>

    </div>

</template>
<script setup lang="ts">
// import CustomHeader from '@/components/common/customHeader.vue';
import { ref } from 'vue'
const availableBalance = ref(0);
const activityIntro = ref('')
const commissionList = ref([
    {
        "level": "1",
        "title": "-100,00",
        "value": "5%"
    },
    {
        "level": "2",
        "title": "-1.000,00",
        "value": "6%"
    },
    {
        "level": "3",
        "title": "-5.000,00",
        "value": "7%"
    },
    {
        "level": "4",
        "title": "-10.000,00",
        "value": "8%"
    },
    {
        "level": "5",
        "title": "-30.000,00",
        "value": "9%"
    },
    {
        "level": "6",
        "title": "-50.000,00",
        "value": "10%"
    },
    {
        "level": "7",
        "title": "-100.000,00",
        "value": "15%"
    },
    {
        "level": "8",
        "title": "-500.000,00",
        "value": "30%"
    }
]);
</script>
<style scoped>
.week_container {
    min-height: 100vh;
    padding: 0rem 1rem;
}

.weekly-banner {
    max-width: 100%;
    margin: 0 auto;
    position: relative;
}

.weekly-img {
    width: 100%;
    height: auto;
    display: block;
    position: absolute;
}

.activity-title-row {
    display: flex;
    align-items: center;
    margin: 5vh 0vh 0vh;
}

.detail-table {
    display: flex;
    align-items: center;
    margin: 43vh 0vh 0vh;
}

.left-img {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-right: 0.2rem;
}

.activity-title {
    color: #FFFFFFD9;
    font-size: 15px;
    display: flex;
    justify-content: center
}

.right-img {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-left: 0.2rem;
}

.activity-text {
    color: #FFFFFF73;
    font-size: 14px;
    margin: 10px 0px;
    line-height: 20px;
}

.top-box {
    padding: 24px 0px;
    position: relative;
    padding-top: 27vh;
}

.top-text {
    position: absolute;
    top: 3vh;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 14px;
    pointer-events: none;
    text-align: center;
    white-space: nowrap;
}

.top-profit {
    position: absolute;
    top: 9.2rem;
    left: 32%;
    transform: translate(-50%, -50%);
    color: #00000073;
    font-size: 13px;
}

.top-compensation {
    position: absolute;
    top: 7.1rem;
    left: 41%;
    transform: translate(-50%, -50%);
    color: #00000073;
    font-size: 13px;
    white-space: nowrap;
}

.middle-compensation {
    position: absolute;
    top: 1.9rem;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 13px;
    white-space: nowrap;
}

.middle-date {
    position: absolute;
    top: 3.5rem;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap
}

.middle-available-compensation {
    position: absolute;
    top: 9.1rem;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 15px;
    white-space: nowrap
}

.middle-available-amount {
    position: absolute;
    top: 10.9rem;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 17px;
}

.top-card-bg,
.middle-card-bg {
    width: 100%;
    height: auto;
    display: block;
    position: absolute;
}

.compensation-card {
    max-width: 100%;
    margin: 0 auto;
    padding-top: 27vh;
    position: relative;
}

.compensation-middle-card {
    max-width: 100%;
    margin: 0 auto;
    padding-top: 0vh;
    position: relative;
}

.from,
.to {
    color: #00000073;
    font-size: 13px;
}

.from-date,
.to-date {
    color: #000;
    font-size: 13px;
}

.top-compensation-amount {
    position: absolute;
    top: 7.1rem;
    left: 88%;
    transform: translate(-50%, -50%);
    color: #00000073;
    font-size: 14px;
}

.top-profit-amount {
    position: absolute;
    top: 9.1rem;
    left: 88%;
    transform: translate(-50%, -50%);
    color: #00000073;
    font-size: 14px;
}

.middle-time-icon {
    position: absolute;
    top: 3.5rem;
    left: 31%;
    transform: translate(-50%, -50%);
    width: 5%;
    filter: invert(100%);
}

.middle-moneybag-icon {
    position: absolute;
    top: 6.8rem;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12%;
}

.exchange-btn {
    background-color: transparent;
    width: 8.33rem;
    height: 9.33rem;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 40vh;
    left: 50%;
    transform: translate(-50%, -50%);
}

.exchange-btn-disabled {
    background-image: url('@/assets/WeeklyCompensation/weekb_btn_disable.png');
    background-size: contain;
    background-repeat: no-repeat;
}

.exchange-btn-active {
    background-image: url('@/assets/WeeklyCompensation/weekb_btn_disable.png');
    background-size: contain;
    background-repeat: no-repeat;
}

.table-title {
    text-align: center;
    background: #f5deb32e;
    padding: 0.7rem 0;
    border-radius: 0.4rem;
}

.table-row {
    text-align: center;
    padding: 0.7rem 0;
    border-radius: 0.4rem;
}

.light {
    background: #ffffff05;
}

.dark {
    background: #ffffff14;
}
</style>